const state = {
    isMembershipToBeShown: true,
    isPatientAddToBeShown: false,
    isPatientsToBeShown: true,
};

const getters = {
    isMembershipToBeShown(state) {
        return state.isMembershipToBeShown;
    },
    isPatientsToBeShown(state){
        return state.isPatientsToBeShown;
    }
};

const mutations = {
    SET_IS_MEMBERSHIP_TO_BE_SHOWN(state, value) {
        state.isMembershipToBeShown = value;
    },
    SET_IS_PATIENTS_TO_BE_SHOWN(state, value) {
        state.isPatientsToBeShown = value;
    },
    SET_IS_PATIENT_ADD_TO_BE_SHOWN(state, value) {
        state.isPatientAddToBeShown = value;
    }
};

export default {
    state,
    getters,
    mutations,
};